import { useMutation, useQueryClient } from 'react-query';
import { apiService } from '@/src/services/api-service';
import { HOME_MOVES_ENDPOINTS } from './endpoints';
import {
  CreateMoveOutRequestBody,
  CreateMoveOutSuccessResponse,
  CreateMoveOutErrorResponse,
} from './types';

type CreateMoveOutInput = {
  accountId: string;
  data: CreateMoveOutRequestBody;
};

export function useCreateMoveOutMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    CreateMoveOutSuccessResponse,
    CreateMoveOutErrorResponse,
    CreateMoveOutInput
  >(
    async ({ accountId, data }) => {
      const response = await apiService.post<CreateMoveOutSuccessResponse>({
        url: HOME_MOVES_ENDPOINTS.createMoveOut(accountId),
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response;
    },
    {
      onSuccess: (_, variables) => {
        // Also invalidate old queries for backward compatibility during migration
        queryClient.invalidateQueries(`moveout-kapi-${variables.accountId}`);
      },
      onError: error => {
        console.error('Error creating move-out:', error);
      },
    },
  );
}
